import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import ReferralsPage from '@/pages/ReferralsPage';
import SignatureQueuePage from '@/pages/SignatureQueuePage';

export default function UnderwritingModule() {
  const tabs = [
    { id: 'referral-queue', label: 'Referral Queue', content: <ReferralsPage /> },
    { id: 'signatures', label: 'Signature Queue', content: <SignatureQueuePage /> },
  ];

  return (
    <ModuleShell title="Underwriting" subtitle="ARIA sends only exception risks here for a human decision — routine new business is scored, rated and bound autonomously" tabs={tabs} />
  );
}
